export type {
  TeachingPopoverHeaderBaseProps as TeachingPopoverHeaderProps,
  TeachingPopoverHeaderBaseState as TeachingPopoverHeaderState,
  TeachingPopoverHeaderSlots,
} from '@fluentui/react-teaching-popover';
